const drawerWidth = 254;

export const drawerStyles = (theme) => ({
  root: {
    display: "flex",
  },
  toolbar: {
    height: 75,
    minHeight: 75,
    display: "flex",
    alignItems: "center",
    paddingLeft: 20,
    borderBottom: "0.1px solid black",
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    minHeight: 75,
    marginLeft: drawerWidth,
    background: "white",
    boxShadow: "0px 0px 1px -1px lavender",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    overflow: "hidden",
  },
  drawerPaper: {
    width: drawerWidth,
    boxShadow: "0px 0px 3px -1px lavender",
    border: 0,
    overflow: "hidden",
  },
  content: {
    flexGrow: 1,
    marginTop: 70,
    // padding: "0px 30px",
    width: "70%",
    overflow: "hidden",
    backgroundColor: "#fbfcfd",
    // padding: theme.spacing(3)
  },
  appbaricons: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  appabarlastlogin: {
    height: 20,
  },
  appabarring: {
    height: 20,
    marginLeft: 20,
    marginRight: 20,
  },
  appabarlogout: {
    cursor: "pointer",
    height: 35,
    marginLeft: 20,
    marginRight: 20,
  },
  lastlogindiv: {
    display: "flex",
    marginRight: 20,
  },
  lastloginmain: {
    color: "gray",
    fontSize: 12,
    marginLeft: 5,
    fontWeight: 600,
  },
  lastloginsub: {
    color: "#003d7b",
  },
  profile: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 5,
  },
  profileimage: {
    background: "#043b72",
    display: "flex",
    marginLeft: 30,
    color: "white",
    fontSize: 20,
    fontWeight: 100,

    alignItems: "center",
    justifyContent: "center",

    height: 60,
    width: 60,
    // marginRight: 25,
    borderRadius: "50%",
  },
  profileRole: {
    backgroundColor: "#feefe2",
    padding: "5px 20px 5px 10px",
    borderTopRightRadius: 30,
    borderBottomRightRadius: 30,
  },
  profileRoletext: {
    color: "#586266",
    fontSize: 12,
  },
  profileRolesubtext: {
    color: "#005DAC",
    fontFamily: "Rubik-Bold",
    fontSize: 12,
  },
  profileSettings: {
    display: "flex",
    alignItems: "center",
    padding: 10,
    marginRight: 5,
    border: "1px solid lightgray",
    borderRadius: 5,
    boxShadow: "0px 0px 0px 1px lavender",
  },
  profileSettingsicon: {
    height: 30,
    width: 35,
    marginRight: 10,
  },
  profileName: {
    color: "black",
    fontSize: 15,
    marginTop: 10,
    textAlign: "center",
  },
  profilenametext: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  profilenameMaintext: {
    display: "flex",
    justifyContent: "flex-end",
    fontSize: 13,
    color: "#596679",
    textAlign: "center",
  },
  profilediv: {
    paddingBottom: 15,
  },
  profilenamesubtext: {
    color: "black",
    fontSize: 15,
    marginLeft: 5,
  },
  combined: {
    margin: "10px 0px",
  },
  list: {
    margin: "0px 10px",
    padding: "20px 0px 40px",
    overflowX: "hidden",
    overflowY: "scroll",
    marginBottom: "20px",
  },
  listImage: {
    marginLeft: 12,
    height: 15,
  },
  listTextActive: {
    fontSize: 15,
    marginLeft: 15,
    color: "white",
  },

  listText: {
    fontSize: 15,
    marginLeft: 12,
    color: "#586a82",
  },
});

export const dashboardStyles = (theme) => ({
  card: {
    display: "flex",
    width: "33%",
    height: 100,
    margin: "0px 10px",
  },
  details: {
    display: "flex",
    flexDirection: "column",
  },
  content: {
    flex: "1 0 auto",
    display: "flex",
    paddingBottom: 0,
    flexDirection: "column",
    justifyContent: "center",
  },
  cover: {
    width: 151,
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
});

export const simpleCardsStyles = (theme) => ({
  card: {
    display: "flex",
    alignItems: "center",
    width: "33.33%",
    marginTop: 1,
    padding: "16px 15px",
    boxShadow: "0px 0px 3px 1px lavender",
    margin: "0px 10px",
    flexGrow: 1,
  },

  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: 0,
  },
  displaySimpleCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  simpletwo: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
  },
  details: {
    margin: "0px 20px",
  },
  name: {
    fontSize: 14,
  },
  count: {
    fontSize: 18,
  },
});
